module.exports = __webpack_public_path__ + "assets/img/小文估值.02004985.png";